<template>
  <div class="WeeklyPOReport">
    <div class="box-card">
      <el-row style="margin-bottom: 16px">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/home' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Weekly PO Report</el-breadcrumb-item>
        </el-breadcrumb>
      </el-row>
      <el-row>
        <el-form ref="searchForm" :model="searchForm" size="small" :label-position="'left'">
          <div style="display: flex" class="vg_mb_8">
            <div class="vg_mr_8">
              <el-form-item label="Original Ship" :label-width="'100px'" prop="original_ship">
                <el-date-picker
                  v-model="searchForm.original_ship"
                  type="daterange"
                  align="right"
                  value-format="yyyy-MM-dd"
                  unlink-panels
                  range-separator="-"
                  start-placeholder="start date"
                  end-placeholder="end date"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="vg_mr_8">
              <el-form-item label="PO#" :label-width="'40px'" prop="po">
                <el-input @change="getData" v-model="searchForm.po" clearable placeholder="Please enter"></el-input>
              </el-form-item>
            </div>
            <div class="vg_mr_8">
              <el-form-item label="Sku" :label-width="'50px'" prop="sku">
                <el-input @change="getData" v-model="searchForm.sku" clearable placeholder="Please enter"></el-input>
              </el-form-item>
            </div>
            <div class="vg_mr_8">
              <el-form-item label="Description" :label-width="'80px'" prop="description">
                <el-input @change="getData" v-model="searchForm.description" clearable placeholder="Please enter"></el-input>
              </el-form-item>
            </div>
            <div class="vg_mr_8">
              <el-form-item label="Country" :label-width="'80px'" prop="country">
                <el-select @change="getData" v-model="searchForm.country">
                  <el-option
                    v-for="item in [
                      { value: 'erp', label: 'China' },
                      { value: 'ems', label: 'Cambodia' }
                    ]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div style="display: flex; align-items: baseline">
              <el-button size="mini" type="primary" @click="search()">Search</el-button>
              <el-button size="mini" type="info" @click="resetSearchForm()">Reset</el-button>
              <el-button size="mini" type="success" @click="exportExcel()">Export to Excel</el-button>
              <el-button size="mini" type="warning" @click="pushFactorySnapshot()">Push Bark</el-button>
            </div>
          </div>
          <div style="display: flex">
            <el-input v-model="localSearchInput" size="small" clearable placeholder="Keyword filter table current page data..."></el-input>
            <el-radio-group
              @input="changePageSearch(1)"
              v-model="searchForm.shipmentStatus"
              style="width: 350px; margin-left: auto; display: flex; align-items: center; justify-content: center"
            >
              <el-radio label="">All</el-radio>
              <el-radio label="未出运">Not shipped</el-radio>
              <el-radio label="已出运">Shipped</el-radio>
            </el-radio-group>
          </div>
        </el-form>
      </el-row>
      <el-row v-loading="loading">
        <el-col :span="24">
          <el-table
            :height="currentInnerHeight"
            ref="table"
            :data="computedTableData"
            border
            :cell-class-name="'cellClassName'"
            class="mtrlsTable"
            :show-summary="true"
            :summary-method="getAllSummaries"
            style="width: 100%"
            @sort-change="getData"
            @selection-change="handleSelectionChange"
          >
            <el-table-column align="center" type="index" width="60" />
            <el-table-column align="center" type="selection" width="55" :selectable="checkSelectable" />
            <el-table-column align="left" label="Category" prop="category" min-width="120" />
            <el-table-column align="left" label="Class" prop="classCode" min-width="120" />
            <el-table-column align="left" label="Month/ Retailer" prop="monthRetailer" min-width="140" />
            <el-table-column align="left" label="PO#" prop="po" min-width="120" sortable="custom" />
            <el-table-column align="left" label="SKU#" prop="sku" min-width="120" />
            <el-table-column align="left" label="Description" prop="description" min-width="120" />
            <el-table-column align="left" label="PO Qty" prop="poQty" min-width="120" />
            <el-table-column align="left" label="Inner Case Counts" prop="innerCaseCounts" min-width="120" />
            <el-table-column align="left" label="Factory" prop="factory" min-width="120" />
            <el-table-column align="left" label="Original PO Ship Date" prop="originalPoShipDate" min-width="120" sortable="custom" />
            <el-table-column align="left" label="Materials Received? Y/N" prop="materialsReceived" min-width="180" />
            <el-table-column align="left" label="Plush" prop="plush" min-width="120" />
            <el-table-column align="left" label="Hardcore" prop="hardcore" min-width="120" />
            <el-table-column align="left" label="Factory Ready Date" prop="factoryReadyDate" min-width="120" sortable="custom" />
            <el-table-column align="left" label="Est PSI Date" prop="estPsiDate" min-width="120" sortable="custom" />
            <el-table-column align="left" label="Actual PSI Date" prop="actualPSIDate" min-width="120" sortable="custom" />
            <el-table-column align="left" label="Est Lab Testing Date" prop="estLabTestingDate" min-width="120" sortable="custom" />
            <el-table-column align="left" label="Lab Results Received" prop="labResultsReceived" min-width="120" sortable="custom" />
            <el-table-column align="left" label="Est Cargo Booking Date" prop="estCargoBookingDate" min-width="140" sortable="custom" />
            <el-table-column align="left" label="Actual Cargo Booking Date" prop="actualCargoBookingDate" min-width="140" sortable="custom" />
            <el-table-column align="left" label="CRD" prop="crd" min-width="140" sortable="custom" />
            <el-table-column align="left" label="Remark" prop="remark" min-width="140" />
          </el-table>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px; text-align: right">
        <el-pagination
          @current-change="changePageSearch"
          @size-change="changeSizeSearch"
          :current-page="currentPage"
          :page-sizes="[100, 200, 500, 1000, 2000]"
          :page-size="searchForm.page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItem"
        />
      </el-row>
    </div>
  </div>
</template>

<script>
import { BigNumber } from 'bignumber.js';
import { get, post } from '@api/request';
import { dyjAPI } from '@api/modules/dyj';
import { downloadFile } from '@assets/pubjs/common';

export default {
  name: 'WeeklyPOReport',
  components: {},
  data() {
    return {
      searchForm: {
        page_no: 1,
        page_size: 100,
        original_ship: [],
        po: '',
        sku: '',
        description: '',
        country: 'erp'
      },
      tableData: [],
      totalItem: 0,
      currentPage: 1,
      loading: false,
      multipleSelection: [],
      localSearchInput: '',
      currentInnerHeight: null,
      pickerOptions: {
        shortcuts: [
          {
            text: 'last week',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'last three months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }
    };
  },
  computed: {
    computedTableData() {
      return this.tableData.filter(
        data => !this.localSearchInput || Object.values(data).some(value => String(value).toLowerCase().includes(this.localSearchInput.toLowerCase()))
      );
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    let { y } = this.$refs.table.$el.getBoundingClientRect();
    this.currentInnerHeight = window.innerHeight - y - 60 + 'px';
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout();
    });
  },
  methods: {
    initData() {
      this.getData();
    },
    // 获取所有的物料信息
    getData(sort) {
      this.loading = true;
      let searchForm = JSON.parse(JSON.stringify(this.searchForm));
      searchForm.column = sort ? sort.prop : '';
      searchForm.order = sort ? (sort.order === 'ascending' ? 'asc' : 'desc') : '';
      searchForm.page_no = this.currentPage;
      if (searchForm.original_ship && searchForm.original_ship.length === 2) {
        searchForm.startTime = searchForm.original_ship[0];
        searchForm.endTime = searchForm.original_ship[1];
        searchForm.original_ship = null;
      }
      get(dyjAPI.getWeeklyPoReport, searchForm)
        .then(({ data }) => {
          if (data.code === 0) {
            this.tableData = data.data.list;
            this.totalItem = data.data.total;
          } else {
            this.$message.error(data.msg);
          }
          this.loading = false;
        })
        .catch(err => console.info(err));
    },
    // 分页查询
    changePageSearch(val) {
      this.currentPage = val;
      this.getData();
    },
    changeSizeSearch(val) {
      this.searchForm.page_size = val;
      this.changePageSearch(1);
    },
    // 搜索按钮
    search() {
      this.currentPage = 1;
      this.changePageSearch(1);
    },
    // 重置按钮
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.changePageSearch(1);
    },
    // 多选变化
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 只有 sconPartId 不为 null 的行才能勾选
    checkSelectable(row) {
      return row.sconPartId !== null && row.sconPartId !== undefined;
    },
    // 推送工厂快照
    pushFactorySnapshot() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('Please select at least one record');
        return;
      }
      const sconPartIdList = this.multipleSelection.map(item => item.sconPartId);
      post(dyjAPI.pushFactorySnapshot, sconPartIdList)
        .then(({ data }) => {
          if (data.code === 0) {
            this.$message.success(data.msg || 'Push successfully');
          } else {
            this.$message.error(data.msg);
          }
        })
        .catch(err => console.info(err));
    },
    exportExcel() {
      let searchForm = JSON.parse(JSON.stringify(this.searchForm));
      if (searchForm.original_ship && searchForm.original_ship.length === 2) {
        searchForm.startTime = searchForm.original_ship[0];
        searchForm.endTime = searchForm.original_ship[1];
        searchForm.original_ship = null;
      }
      get(dyjAPI.exportWeeklyPoReport, searchForm)
        .then(({ data }) => {
          if (data.code === 0) {
            downloadFile({ fileUrl: data.data.url, fileName: data.data.fileName });
          } else {
            this.$message.error(data.msg);
          }
          this.loading = false;
        })
        .catch(err => console.info(err));
    },
    getAllSummaries({ columns, data }) {
      return columns.map((column, index) => {
        if (index === 0) return 'Total';
        if (['sku'].includes(column.property)) return '';
        const values = data.map(item => Number(item[column.property] || 0));
        const sum = values.reduce((x, item) => x.plus(item), new BigNumber(0)).toNumber();
        return sum || '';
      });
    }
  }
};
</script>
<style scoped>
::v-deep.el-table th > .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
::v-deep.el-table td > .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
<style>
.WeeklyPOReport .box-card {
  height: 100%;
  margin: 20px 40px 0 230px;
  padding-bottom: 10px;
}
.WeeklyPOReport .mtrlsTable {
  margin-top: 20px;
}
.cellClassName {
  padding: 0 !important;
}
</style>
